import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FormContext } from "../context/FormContext";
import Header from "./Header";

const TopicScreen = () => {
  const [topic, setTopic] = useState("");
  const navigate = useNavigate();
  const { updateFormData } = useContext(FormContext);

  const handleNext = () => {
    if (topic.trim()) {
      updateFormData({ topic });
      navigate("/subtopics", { state: { topic } });
    }
  };

  return (
    <div>
      <Header />
      <div className="center flex flex-col items-center h-screen">
        <div className="flex flex-col items-start justify-center w-full h-screen gap-6 max-w-sm md:max-w-md">
          <h2 className="text-[#0D3C26] text-2xl">What are you trying to learn?</h2>
          <div className="w-full rounded-full flex bg-white px-4 justify-between items-center h-14">
            <input
              type="text"
              value={topic}
              className="placeholder:text-[#0d3c26b2] w-full  focus:outline-none outline-none text-[#0D3C26] text-base md:text-xl "
              onChange={(e) => setTopic(e.target.value)}
              placeholder="Topic"
            />
            
            <button disabled={!topic}  className={`bg-[#FAF3EA] rounded-full px-3 py-1.5 text-[#0D3C26] disabled:text-[#7b7b77] font-semibold  text-center flex justify-center items-center`} onClick={handleNext}>Continue</button>

            
          </div>
          <div className="flex flex-col items-start gap-4">
            <h2 className="text-[#0D3C26] font-bold text-xl md:text-2xl">
              Example
            </h2>
            <ul className="text-[#0D3C26] text-base list-disc px-4">
              <li>Operating System</li>
              <li>System Design</li>
              <li>Artificial Intelligence</li>
            </ul>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default TopicScreen;
